import React from 'react';

interface ErrorAlertProps {
  message: string;
  className?: string;
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({ message, className = '' }) => {
  if (!message) return null;
  return (
    <div className={`mb-4 p-3 bg-alert/10 border border-alert rounded-md ${className}`.trim()}>
      <p className="text-sm text-alert">{message}</p>
    </div>
  );
};

export default ErrorAlert; 